import { Box, Heading, Text } from '@chakra-ui/react'

const Fundamentals = () => (
  <Box>
    <Heading as="h4" size="md" mt={6} mb={2}>
      Understanding the Strategy Fundamentals
    </Heading>
    <Text mb={4}>
      This strategy operates on a fundamental principle: Bitcoin price movement is influenced by market sentiment. When positive sentiment (<b>Good</b>) outweighs negative sentiment (<b>Very Bad</b>), prices tend to rise. The strategy exploits this relationship through a simple ratio that serves as our primary decision-making tool.
    </Text>
  </Box>
)

export default Fundamentals
